(function () {
  function isBargainProductPage() {
    return (
      document.body.classList.contains("template-product-bargain") ||
      (document.body.classList.contains("bargains-nav-active") &&
        document.body.classList.contains("template-product"))
    );
  }

  function getBargainInsets() {
    const isDesktop = window.matchMedia("(min-width: 750px)").matches;
    return {
      main: isDesktop ? "9.6rem" : "4.8rem",
      thumb: isDesktop ? "2.4rem" : "1.2rem",
    };
  }

  function applyUniformProductMedia(container) {
    const isBargainPdp = isBargainProductPage();
    const insets = isBargainPdp
      ? getBargainInsets()
      : { main: "3.2rem", thumb: "0.8rem" };
    const mainInset = insets.main;
    const thumbInset = insets.thumb;

    container
      .querySelectorAll(
        ".product__media-list .product__media, .product__media-list .deferred-media"
      )
      .forEach((media) => {
        media.classList.add("media", "media--transparent", "media--uniform-thumb");
        media.style.setProperty("aspect-ratio", "1 / 1", "important");
        media.style.setProperty("height", "auto", "important");
        media.style.setProperty("padding-top", "0", "important");
        media.style.setProperty("position", "relative", "important");
      });

    container
      .querySelectorAll(
        ".product__media-list .product__media img, .product__media-list .deferred-media img, .product__media-list .deferred-media__poster img"
      )
      .forEach((img) => {
        img.style.setProperty("position", "absolute", "important");
        img.style.setProperty("top", "50%", "important");
        img.style.setProperty("left", "50%", "important");
        img.style.setProperty("right", "auto", "important");
        img.style.setProperty("bottom", "auto", "important");
        img.style.setProperty("width", `calc(100% - ${mainInset})`, "important");
        img.style.setProperty("height", `calc(100% - ${mainInset})`, "important");
        img.style.setProperty("max-width", `calc(100% - ${mainInset})`, "important");
        img.style.setProperty("max-height", `calc(100% - ${mainInset})`, "important");
        img.style.setProperty("object-fit", "contain", "important");
        img.style.setProperty("object-position", "center center", "important");
        img.style.setProperty("transform", "translate(-50%, -50%)", "important");
      });

    container
      .querySelectorAll(".product__media-subitem .product__media")
      .forEach((media) => {
        media.classList.add("media", "media--transparent", "media--uniform-thumb");
        media.style.setProperty("aspect-ratio", "1 / 1", "important");
        media.style.setProperty("height", "auto", "important");
        media.style.setProperty("padding-top", "0", "important");
        media.style.setProperty("position", "relative", "important");
      });

    container
      .querySelectorAll(".product__media-subitem .product__media img")
      .forEach((img) => {
        img.style.setProperty("position", "absolute", "important");
        img.style.setProperty("top", "50%", "important");
        img.style.setProperty("left", "50%", "important");
        img.style.setProperty("width", `calc(100% - ${thumbInset})`, "important");
        img.style.setProperty("height", `calc(100% - ${thumbInset})`, "important");
        img.style.setProperty("max-width", `calc(100% - ${thumbInset})`, "important");
        img.style.setProperty("max-height", `calc(100% - ${thumbInset})`, "important");
        img.style.setProperty("object-fit", "contain", "important");
        img.style.setProperty("object-position", "center center", "important");
        img.style.setProperty("transform", "translate(-50%, -50%)", "important");
      });
  }

  function getProductPageRoot(container) {
    if (!container) return null;
    if (container.id && container.id.startsWith("MainProduct-")) {
      return container;
    }
    return container.querySelector('[id^="MainProduct-"]');
  }

  function initProductPage(container) {
    const root = getProductPageRoot(container);
    if (!root) return;

    applyUniformProductMedia(root);

    root.querySelectorAll(".js-media-list").forEach((elem) => {
      const isHorizontalThumbs = elem
        .closest(".product__media-list-wrapper")
        ?.classList.contains("horizontal-thumbnails");

      if (elem.swiper) {
        elem.swiper.params.autoHeight = false;
        if (isHorizontalThumbs) {
          elem.style.removeProperty("height");
          elem.querySelector(".swiper-wrapper")?.style.removeProperty("height");
        }
        elem.swiper.update();
      }
    });
  }

  window.initProductPage = initProductPage;

  // Toggle content
  $(document).on("click", ".product-description-more", function (e) {
    e.preventDefault();
    $(this)
      .closest(".product-description-short")
      .next(".product-description-full")
      .show();
    $(this).closest(".product-description-short").hide();
  });

  $(document).on("click", ".product-description-less", function (e) {
    e.preventDefault();
    $(this)
      .closest(".product-description-full")
      .prev(".product-description-short")
      .show();
    $(this).closest(".product-description-full").hide();
  });

  // Toggle fields
  $(document).on("click", ".js-show-more", function (e) {
    e.preventDefault();
    $(this).siblings("input").removeClass("hidden");
    $(this).siblings("label").removeClass("hidden");
    $(this).remove();
  });
})();

/* Second floated product form */
if (!customElements.get("floated-form")) {
  class FloatedForm extends HTMLElement {
    constructor() {
      super();
      this.renderForm();
    }

    renderForm() {
      fetch(this.getAttribute("data-product-url"))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          this.productElement = responseHTML.querySelector(
            'div[id^="ProductInfo-"]'
          );

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.showMoreFields();
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        const newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(
          document.createTextNode(oldScriptTag.innerHTML)
        );
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
        sectionId,
        `floated-${sectionId}`
      );

      if (this.productElement.querySelectorAll("variant-selects")) {
        this.productElement
          .querySelectorAll("variant-selects")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }

      if (this.productElement.querySelectorAll("variant-radios")) {
        this.productElement
          .querySelectorAll("variant-radios")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }
    }

    removeDOMElements() {
      const text = this.productElement.querySelector(".product__text");
      if (text) text.remove();

      const shareButtons = this.productElement.querySelector(".share-buttons");
      if (shareButtons) shareButtons.remove();

      const rating = this.productElement.querySelector(".rating");
      if (rating) rating.remove();

      const tags = this.productElement.querySelector(".product-tags");
      if (tags) tags.remove();

      const description = this.productElement.querySelector(
        ".product__description"
      );
      if (description) description.remove();

      const advantages = this.productElement.querySelectorAll(".advantage");
      advantages.forEach((advantage) => {
        advantage.remove();
      });

      const note = this.productElement.querySelector(".note");
      if (note) note.remove();

      const promoBanner = this.productElement.querySelector(".promo-banner");
      if (promoBanner) promoBanner.remove();

      const pickupAvailability = this.productElement.querySelector(
        "pickup-availability"
      );
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector("product-modal");
      if (productModal) productModal.remove();

      const productForm = this.productElement.querySelector("floated-form");
      if (productForm) productForm.remove();

      const relatedProduct =
        this.productElement.querySelector("related-product");
      if (relatedProduct) relatedProduct.remove();

      const gift = this.productElement.querySelector(".customer");
      if (gift) gift.remove();

      const customLiquid = this.productElement.querySelector(".custom-liquid");
      if (customLiquid) customLiquid.remove();
    }

    showMoreFields() {
      $(".js-show-more").click(function (e) {
        e.preventDefault();
        $(this).siblings("input").removeClass("hidden");
        $(this).siblings("label").removeClass("hidden");
        $(this).remove();
      });
    }
  }

  customElements.define("floated-form", FloatedForm);
}
